import { createAction } from '@reduxjs/toolkit';

import { CloseNotificationPayload, RemoveNotificationPayload, EnqueueNotificationPayload } from '../../models';

export const enqueueNotification = createAction<EnqueueNotificationPayload>('notifications/enqueueNotification');
export const closeNotification = createAction<CloseNotificationPayload>('notifications/closeNotification');
export const removeNotification = createAction<RemoveNotificationPayload>('notifications/removeNotification');
